var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cellList.length > 0)?_c('div',{staticClass:"single-banner-container",style:(_vm.getColor)},[_c('SingleBannerItem',{attrs:{"bannerInfo":_vm.cellList[0]}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }